
      import { createComponent } from '@lit/react'
      import { type EventName } from '@lit/react'
      import * as React from 'react'

      import Component from '../../components/toc/toc.component.js'
      import type { DdsAnchorChangeEvent } from '../../events/events'
      export type { DdsAnchorChangeEvent } from '../../events/events'

      const tagName = 'dap-ds-toc'

      /**
 * `dap-ds-toc`
 * @summary A table of contents (TOC) is a list of links that allows users to quickly navigate to sections within a document.
 * @element dap-ds-toc
 * @title - toc
 *
 * @property {'sm' | 'lg'} size - The size of the toc. Default is `lg`.
 *
 * @event {{ selectedItem: HTMLAnchorElement, anchorElement: IntersectionObserverEntry | HTMLElement }} dds-anchor-change - Event that is triggered when the anchor changes.
 *
 * @csspart base - The main container of the toc.
 *
 * @cssproperty --dds-toc-border-width - Width of the TOC border. Default: var(--dds-border-width-base)
 * @cssproperty --dds-toc-border-color - Color of the TOC border. Default: var(--dds-border-neutral-divider)
 * @cssproperty --dds-toc-title-color - Color of the TOC title. Default: var(--dds-text-neutral-strong)
 * @cssproperty --dds-toc-title-font-size - Font size of the TOC title. Default: var(--dds-font-base)
 * @cssproperty --dds-toc-title-font-weight - Font weight of the TOC title. Default: var(--dds-font-weight-bold)
 * @cssproperty --dds-toc-title-line-height - Line height of the TOC title. Default: 1.25
 * @cssproperty --dds-toc-link-color - Color of the TOC links. Default: var(--dds-button-subtle-text-neutral-enabled)
 * @cssproperty --dds-toc-link-active-color - Color of the active TOC link. Default: var(--dds-button-subtle-text-enabled)
 * @cssproperty --dds-toc-link-border-color - Border color of the active TOC link. Default: var(--dds-border-brand-base)
 * @cssproperty --dds-toc-link-line-height - Line height of the TOC links. Default: 1.2
 * @cssproperty --dds-toc-link-padding - Padding of the TOC links. Default: var(--dds-spacing-200)
 */
      const reactWrapper = createComponent({
        tagName,
        elementClass: Component,
        react: React,
        events: {
          onDdsAnchorChange: 'dds-anchor-change' as EventName<DdsAnchorChangeEvent>
        },
        displayName: "DapDSTOC"
      })

      export default reactWrapper
    